import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { ChakraProvider, Link, Box, Icon } from "@chakra-ui/react";
import { FiArrowUpRight } from "react-icons/fi";
import theme from "./theme/theme";
import Home from "./components/Home";
import "./styles/global.css";
import About from "./components/About";
import Experience from "./components/Experience";
import Projects from "./components/Projects";
import Skills from "./components/Skills";
import Contact from "./components/Contact";
import Navbar, { SIDEBAR_WIDTH } from "./components/Navbar";
import Footer from "./components/Footer";
import { accent } from "./constants/constants";

const App: React.FC = () => {
  return (
    <ChakraProvider theme={theme}>
      <Router>
        <Link
          href="#main-content"
          position="fixed"
          top="-100%"
          left="4"
          zIndex={300}
          bg="brand.accent"
          color="brand.bg"
          px={4}
          py={2}
          borderRadius="md"
          fontWeight={700}
          _focus={{ top: "4" }}
          _focusVisible={{ top: "4" }}
        >
          Skip to main content
        </Link>
        <Navbar />
        <Box pl={{ base: 0, md: SIDEBAR_WIDTH }}>
          <Box as="main" id="main-content" tabIndex={-1}>
            <Home />
            <About />
            <Experience />
            <Skills />
            <Projects />
            <Contact />
          </Box>
          <Footer />
        </Box>
        <Link
          href="#contact"
          position="fixed"
          bottom={{ base: 4, md: 8 }}
          right={{ base: 4, md: 8 }}
          zIndex={200}
          fontWeight={700}
          color={accent}
          display={{ base: "none", sm: "inline-flex" }}
          alignItems="center"
          gap={2}
          _hover={{ textDecoration: "none", opacity: 0.8 }}
        >
          <Icon as={FiArrowUpRight} aria-hidden="true" boxSize={5} /> Contact
        </Link>
      </Router>
    </ChakraProvider>
  );
};

export default App;
